import axios from "axios";
import { User } from "../../model/user-management/user.model";

const baseApiUrl = "api/user";

export default class UserService {
  public createClientAndSendEmailFacette(): Promise<User> {
    return new Promise<User>(function (resolve, reject) {
      axios
        .post(baseApiUrl + "/client")
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public sendEmailEssentialToPremium(userID): Promise<User> {
    return new Promise<User>(function (resolve, reject) {
      axios
        .post(baseApiUrl + "/to-premium/"+userID)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public acceptBotCGUs() {
    return new Promise<any>(function (resolve, reject) {
      axios
        .put(baseApiUrl + "/chatbot/cgu")
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public deactivateTooltip(idUser: number, tooltipName: string): Promise<User> {
    let string = { tooltip: tooltipName };
    return new Promise<User>(function (resolve, reject) {
      axios
        .put(baseApiUrl + "/tooltips/deactivate", string)
        .then(function (res) {
          resolve(res.data);
          this.store.commit("setUser", res.data); // update vuex
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public acceptChatbotCgu(): Promise<any> {
    return new Promise<User>(function (resolve, reject) {
      axios
        .put(baseApiUrl + "/chatbot/cgu")
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public updateClient(user: User): Promise<User> {
    return new Promise<User>(function (resolve, reject) {
      axios
        .put(baseApiUrl + "/client", user)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  public assignClientsToUser(idUser: number, listClients): Promise<User> {
    return new Promise<User>(function (resolve, reject) {
      axios
        .put(baseApiUrl + "/" + idUser + "/assign-clients", listClients)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
